/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSum = createReactComponent("outline", "sum", "IconSum", [["path", { "d": "M18 16v2a1 1 0 0 1 -1 1h-11l6 -7l-6 -7h11a1 1 0 0 1 1 1v2", "key": "svg-0" }]]);

export { IconSum as default };
//# sourceMappingURL=IconSum.mjs.map
